import { Component, Input } from '@angular/core';
import { REGEX_DECIMAL } from 'src/app/models/app-constants';
import { convertToAESTDateTime, getTimezoneOffset } from 'src/app/shared/utils';

@Component({
	selector: 'app-tide-forecast',
	templateUrl: './tide-forecast.component.html',
	styleUrls: ['./tide-forecast.component.scss']
})
export class TideForecastComponent {

	private regExpDecimal = new RegExp(REGEX_DECIMAL, "i");

	@Input() FirstTideHighHeight : number | undefined;
	@Input() FirstTideHighTime : string | undefined;
	@Input() FirstTideLowHeight : number | undefined;
	@Input() FirstTideLowTime : string | undefined;
	
	@Input() NextTideHighHeight : number | undefined;
	@Input() NextTideHighTime : string | undefined;
	@Input() NextTideLowHeight : number | undefined;
	@Input() NextTideLowTime : string | undefined;

	@Input() SecondTideHighHeight : number | undefined;
	@Input() SecondTideHighTime : string | undefined;
	@Input() SecondTideLowHeight : number | undefined;
	@Input() SecondTideLowTime : string | undefined;	

	timeZoneOffset = getTimezoneOffset();

	getTideHeight = (height : string | number | undefined) => {

		let htStr = "";
		if(null != height && this.regExpDecimal.test(height?.toString()))
		{
			htStr = `${height?.toString()} m`;
		}

		return htStr;

	}

	getLocalDateTime = (dateTime : any) => {
		return convertToAESTDateTime(dateTime);		
	}
}
